import {
  Autocomplete,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React from "react";

const SelectDropDown = ({ properties }) => {
  console.log(properties.isMultiSelect);
  return (
    <>
      {properties.isAutoSelect ? (
        <Autocomplete
          multiple={properties.isMultiSelect}
          size="small"
          options={properties.options || []} // Ensure options is always array
          defaultValue={[]} // Critical fix
          getOptionLabel={(option) => option}
          renderInput={(params) => (
            <TextField
              {...params}
              label={properties.label}
              variant="outlined"
            />
          )}
        />
      ) : (
        <FormControl fullWidth size="small">
          <InputLabel>{properties.label}</InputLabel>
          <Select label={properties.label}>
            {properties.options.map((option, index) => (
              <MenuItem key={index} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </>
  );
};

export default SelectDropDown;
